/* eslint-disable no-console */
import { get } from "@insite/client-framework/Services/ApiService";

const orderUrl = "/api/v2/recentorderhistory/GetCustomOrderHistory";

export async function getCustomOrderHistory() {
    try {
        const response = await get(orderUrl);
        return response;
    } catch (error) {
        console.log("Error getting orders", error);
        throw new Error("Failed to get orders");
    }
}
